var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonStyle === false ? 'link link--is-button link--secondary save-configuration__link' : 'btn btn--primary btn--full-width save-configuration__button',on:{"click":_vm.showModal}},[_vm._v("Save configuration")]),_vm._v(" "),_c('SaveConfigurationModal',{ref:"saveConfigurationModal"})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7450a46c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/configurator/components/SaveConfiguration.vue
// module id = WJAG
// module chunks = 15